// src/services/api/config.js
import { getSessionId } from './session.js';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_V1 = `${API_BASE_URL}/api/v1`;

// DEV_TOKEN: fallback for local dev without login (set REACT_APP_DEV_TOKEN in .env)
export const DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN || '';

export function getAuthHeaders() {
  const token = localStorage.getItem('auth_token') || DEV_TOKEN;
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

export function getSessionHeaders() {
  return { 'X-Session-Id': getSessionId() };
}
